import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "http://localhost:3010/proxy/basket-ui",
  socialProofApi:
    "http://localhost:3010/proxy/product-badging/api/v1/social-proof-messaging",
};

export default config;
